import { render } from "./BHeader.vue?vue&type=template&id=4437dec0"
import script from "./BHeader.vue?vue&type=script&lang=js"
export * from "./BHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__